import React from 'react';

import { HiOutlineCash } from 'react-icons/hi';

import { Button } from 'modules/common/input';
import { showModal } from 'modules/common/modal';

import { useGetCart, useGetCharges } from '../../hooks';
import ChargesModal from './ChargesModal';

function Charges() {
  const [cart] = useGetCart();
  const [charges, setCharges] = useGetCharges();

  const onButtonClick = () => {
    showModal({
      title: (
        <div>
          <div>Add Charge</div>
          <div className="text-sm font-normal">
            Select extra charges to apply
          </div>
        </div>
      ),
      content: (onClose) => (
        <div className="pt-3">
          <ChargesModal
            onClose={onClose}
            name="selected_charges"
            onChange={(v) => {
              const $v = v()?.selected_charges;
              setCharges($v);
            }}
            value={charges}
          />
        </div>
      ),
      modalSize: 'modal-xs',
    });
  };

  return (
    <div>
      <Button
        className="btn bg-transparent border border-gray-400 w-full text-white"
        disabled={cart?.length <= 0}
        label={
          <div className="flex items-center gap-3 justify-center py-0.5">
            <HiOutlineCash className="h-6 w-6" />
            <div>{charges?.length > 0 ? 'Edit' : 'Add'} Charge</div>
          </div>
        }
        onClick={onButtonClick}
      />
    </div>
  );
}

export default Charges;

Charges.defaultProps = {};

Charges.propTypes = {};
